<template>
    <div class="update-modal">
        <v-card>
            <v-card-text>
                <h4>
                    Your mobile number is not yet verified.<br/>
                    Please verify your number to get updates on your mobile about upcoming tests and results.
                </h4>
                <div class="d-flex justify-center">
                    <v-btn @click="onClose({status: false, checkIfMobileVerified: true, ...data})" class="mr-3" color="secondary">Later</v-btn>
                    <v-btn color="primary" class="cust-btn btn-uppercase" @click="verifyMobile">Verify Now</v-btn>
                </div>
                <div class="text-center">
                    <i>We promise not to share your number with any third party.</i>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: "VerifyMobile",
    props: ["onClose", "status", "data"],
    computed: {
        ...mapState("userStore", ["user"])
    },
    methods: {
        verifyMobile() {
            let telegramLink = this.getTelegramLink(this.user);
            window.open(telegramLink, "_blank");
            this.onClose({ status: false });
        }
    }
};
</script>

